import { createContext } from "react";

export interface Preferences {
  dyslexicFont: boolean;
  toggleDyslexicFont: () => void;
}

export const PreferencesContext = createContext<Preferences | null>(null);